export const createLocalStorage = (name:string, values: string | {}): void => localStorage.setItem(name, JSON.stringify(values));

export const checkInLocalStorage = (name:string):boolean => localStorage.getItem(name) ? true : false;

export const getLocalStorage = (name:string): string | {} => JSON.parse(localStorage.getItem(name));

export const destroyLocalStorage = (name:string): void => localStorage.removeItem(name);